/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  pageHeading: {
    id: "b2b.zdroje-typy-grid.label",
    defaultMessage: "Types of resources"
  }
});

export default () => useMessages(MESSAGES);
